import { isCustomDomain } from 'shared/utils/is-custom-domain'
import { getDashboardHostname } from 'modules/white-label/utils/dashboard-url'

export const getCourseCardLinkTarget = (href: string): '_blank' | '_self' => {
  const url = new URL(href)
  const dashboardHostname = getDashboardHostname()
  const isLinkOnCustomDomain =
    url.host !== dashboardHostname || !!url.searchParams.get('domainName')
  return !isCustomDomain() && isLinkOnCustomDomain ? '_blank' : '_self'
}
